import React from 'react';
import { useSelector } from 'react-redux';
// import { useApp, useModal } from '../_contexts';
import { parseBBCode } from '../_helpers';

import { SidebarCover, SidebarOptions } from './_components';

export function SidebarChronicleDetails(props) {
  const { data: chronicle } = useSelector((state) => state.chronicle);
  const cleanedDescription = parseBBCode(chronicle && chronicle.description);
  return (
    <div className="chronos-sidebar-content chronos-sidebar-chronicle-details-wrapper">
      <SidebarCover name={chronicle.title} />
      <div className="chronos-sidebar-body">
        <div className="chronos-sidebar-type">
          <span>Chronicle</span>
        </div>
        <h4 className="chronos-sidebar-title">{chronicle.title}</h4>
        <hr className="chronos-sidebar-separator" />
        <div
          className="chronos-sidebar-description"
          dangerouslySetInnerHTML={{ __html: cleanedDescription }}
        ></div>
        <SidebarOptions item={{}} type="chronicle" />
      </div>
    </div>
  );
}
